// ============================================================
// CarePlanRoleAssignModal.jsx  (Care Coordinator, role-model expansion Push 2)
// Modal to assign the CarePlan Care Coordinator overlay. Single-value role
// (care_coordinator) — no role picker, no tier (unlike the CarePeople modal);
// a confirm-with-description form. Reuses the cp-role-modal styling.
// ============================================================

import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import Modal from './Modal';
import './CarePeopleRoleAssignModal.css';

export default function CarePlanRoleAssignModal({
  isOpen,
  onClose,
  onSubmit,
  submitting = false,
  errorMessage = null,
}) {
  function handleSubmit(e) {
    e.preventDefault();
    if (submitting) return;
    onSubmit({ carePlanRole: 'care_coordinator' });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Assign Care Coordinator" closeDisabled={submitting}>
      <form className="cp-role-modal" onSubmit={handleSubmit}>
        <p className="cp-role-modal__help">
          Care Coordinator gives roster-wide client visibility across CarePlan, plus
          the client-scoped medical view (tier 2 shown when the client has a scheduled
          visit today). It never widens access to other carers&rsquo; staff records.
        </p>

        {errorMessage && (
          <div className="cp-role-modal__error" role="alert">
            <AlertCircle size={14} />
            <span>{errorMessage}</span>
          </div>
        )}

        <div className="cp-role-modal__actions">
          <button type="button" className="cp-role-modal__cancel" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button type="submit" className="cp-role-modal__submit" disabled={submitting}>
            {submitting && <Loader2 size={14} className="cp-role-modal__spinner" />}
            Assign Care Coordinator
          </button>
        </div>
      </form>
    </Modal>
  );
}
